module.exports = __webpack_public_path__ + "static/img/408fee2ef20478a837af16017e1281c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_disable_04.png
// module id = v51N
// module chunks = 1